<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Negotiation</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="negotiation_fee" type="text" placeholder="Negotiation fee" :class="{ 'is-danger': errors.negotiation_fee }">
                    <span class="icon is-left">
                       <i class="fas fa-headset"></i>
                    </span>
                    <p v-if="errors.negotiation_fee" class="help is-danger">{{ errors.negotiation_fee[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            negotiation_fee: {
                get() {
                    return this.$store.getters.getNewPricePlan.negotiation_fee
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'negotiation_fee', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/NegotiationFeeInput.vue